module.exports = "/images/85cce3228ef2e561f87c826a898b13ee.png";